import React, { useEffect, useState } from 'react'
import avatar from "../../assets/img/default-avatar.png";


type PropsFotoPerfil = {
    src: string,
    onError?: () => void,
    styleimg?:string,
}



export default function FotoPerfil(props: PropsFotoPerfil) {

    const {
        src,
        onError,
        styleimg
    } = props;


    const [stateUrlImg, setstateUrlImg] = useState<string>(src)


    useEffect(() => {
        if(src){
            setstateUrlImg(src);
        }
      
    }, [src])
    

    const handleError = () => {
        if(onError !== undefined && typeof(onError) === "function"){
            onError()
        }
        else{
            setstateUrlImg(avatar)
        }
    }



    return (
        <img src={stateUrlImg} className={styleimg??"img-circle"} onError={handleError} alt='fotoUsuario'/>
    )
}
